import { render, staticRenderFns } from "./TopRanking.vue?vue&type=template&id=1d61a0ab&scoped=true"
import script from "./TopRanking.vue?vue&type=script&lang=js"
export * from "./TopRanking.vue?vue&type=script&lang=js"
import style0 from "./TopRanking.vue?vue&type=style&index=0&id=1d61a0ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d61a0ab",
  null
  
)

export default component.exports